/**
 * Inline screenshot block for SOP tutorials.
 * Renders a centered image with a caption, framed in a rounded card.
 * Source URL is served by the backend at /api/assets/sop_screenshots/{filename}.
 */
const API_BASE = process.env.REACT_APP_BACKEND_URL;

export default function SopImage({ filename, caption, alt }) {
  const src = `${API_BASE}/api/assets/sop_screenshots/${filename}`;
  return (
    <figure
      className="my-5 bg-white border-2 border-gray-200 rounded-2xl p-3 shadow-sm"
      data-testid={`sop-img-${filename}`}
    >
      <img
        src={src}
        alt={alt || caption || filename}
        className="w-full h-auto rounded-lg border border-gray-100"
        loading="lazy"
      />
      {caption && (
        <figcaption className="text-xs text-gray-500 italic text-center mt-2">{caption}</figcaption>
      )}
    </figure>
  );
}
